<template>
  <button
    class="circle-button m-reset-button"
    type="button"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <BaseIcon
      :icon="icon"
      :size="16"
    />
  </button>
</template>

<script setup>
import BaseIcon from '@/components/BaseIcon.vue';

defineProps({
  icon: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['click']);
</script>

<style>
.circle-button {
  border: 1px solid var(--gray-300);
  width: 40px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  &[disabled] {
    opacity: 0.3;
  }
  &:not([disabled]):hover {
    background-color: var(--gray-200);
  }
}
</style>
